export const locale = {
    lang: 'en',
    data: {
        GENERAL_INFO_TAB: {
            TITLES: {
                GENERAL: 'Contact Information',
                CANCEL: 'Cancel',
                SAVE: 'Save',
                EDIT: 'Edit',
            }
        }
    }
};